import { Controller } from "@hotwired/stimulus"
import TokenBuilder from '../src/javascripts/nowsignage/token-builder';

export default class extends Controller {

  connect() {
    TokenBuilder.init($(".tokenfield"));
  }

}